import { ETripType } from "../../enums/trip-type";

export class TripContainer {
    id: number;
    tripId: number;
    containerNumber: string;
    containerNumberTwo: string;
    containerSize: string;
    status: string;
    pickupPoint: string;
    destination: string;
    tripRate: number;
    driverRate: number;
    helperRate: number;
    createdDate: string;
    createdBy: string;
    updatedDate: string;
    updatedBy: string;

    dailyTripDate?: string;
    dailyTripReturnEmptyDate?: string;

    static getStatusDisplayName(tripTypeId: number, status: string, returnEmptyDate?: string): string {
        if(status === 'DONE') return 'Delivered';

        if(status === 'IN_PROGRESS'){
            if(tripTypeId !== ETripType.Import) return 'En route';
            
            if(!returnEmptyDate) return 'En route';
            return 'Returning Empty';
        }
        
        return 'Unshipped';
    }
}

export class TripContainerDto {
    id: number;
    tripId: number;
    containerNumber: string;
    containerNumberTwo: string;
    containerSize: string;
    status: string;
    destination: string;
}


// WEBPACK FOOTER //
// ./src/app/models/trips/tripContainer.ts